import React from "react";
import Axios from "axios";
import ReactStars from "react-rating-stars-component";
import { Avatar, CircularProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";
const Feedbacks = () => {
  const [activity, setactivity] = React.useState([]);

  const fetchStats = async () => {
    const { data } = await Axios({
      method: "get",
      url: `/api/activity/feedbacks`,
    });
    setactivity(data.data);
  };
  React.useEffect(() => {
    fetchStats();
  }, []);
  if (activity === null) {
    return <CircularProgress />;
  }
  const returnDate = (d) => {
    return new Date(d).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };
  const navigate = useNavigate();

  return (
    <div className="container admin-user-activity">
      <h3>Platform Feedbacks({activity.length})</h3>
      {activity ? (
        <>
          <table>
            <tr>
              <th>User</th>
              <th>Date</th>
              <th>Rating</th>
              <th>Liked Features</th>
              <th>Additional Comment</th>
              <th>Least useful</th>
              <th>Meeting Expectations</th>
              <th>Other Feedback</th>
            </tr>
            {activity.length > 0 &&
              activity.map((res, i) => (
                <tr key={i} className="my-2 pt-2">
                  <td
                    onClick={() =>
                      navigate(
                        `/admin/user-activity?tab=13&userid=${res.userid?._id}`
                      )
                    }
                    className="pointer my-2 pt-2"
                  >
                    <Avatar src={res.userid ? res.userid.avatar : ""} />
                    {res.userid
                      ? `${res.userid.name} (${res.userid.email}, ${res.userid.type})`
                      : res.email}
                  </td>
                  <td className=" pt-2">{returnDate(res.createdAt)}</td>

                  <td style={{ width: "120px" }} className="ml-2 my-2 pt-2">
                    <ReactStars
                      count={5}
                      value={res.zefyronRating}
                      size={24}
                      activeColor="#ffd700"
                      edit={false}
                    />
                  </td>
                  <td className=" pt-2">{res.likedFeatures?.join(", ")}</td>

                  <td className=" my-2 pt-2">{res.additionalComments}</td>
                  <td className=" pt-2">{res.leastUseFul}</td>
                  <td className=" pt-2">
                    {res.expectationsMeet} {res.expectationReason}
                  </td>
                  <td className=" pt-2">{res.anyOtherfeedback}</td>
                </tr>
              ))}
          </table>
        </>
      ) : (
        ""
      )}
    </div>
  );
};

export default Feedbacks;
